import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { Client, ISizeName } from '@df/core/service/client';
import { GtmItemDirective } from '@df/module-gtm/integration/gtm-item.directive';
import { GtmListDirective } from '@df/module-gtm/integration/gtm-list.directive';
import { DfUiCarouselModule } from '@df/ui-carousel/carousel.module';
import { DfModal } from '@df/ui/modal/df-modal.decorator';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { MODAL_DATA } from '@df/ui/modal/modal.service';
import { ProductComponent } from '../../../catalog/product/product/product.component';
import { ModalLayoutRightComponent, NModalLayoutRight } from '../../../common/modal/layout-right/modal-layout-right.component';
import { NCmsUGC } from '../cms-ugc.component';

@DfModal({
    id: NCmsUGC.MODAL_ID,
    position: 'right',
    config: (size: ISizeName) => NModalLayoutRight.getConfig(size),
    reopenPolicy: NDfModal.ReopenPolicy.first,
    sizeRestriction: sizeId => ['S', 'M', 'L', 'X']
})
@Component({
    templateUrl: './ugc-modal.html',
    imports: [DfUiCarouselModule, ModalLayoutRightComponent, ProductComponent, GtmListDirective, GtmItemDirective],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UGCModalComponent {
    /**
     * Close ugc
     */
    constructor(
        private modalRef: ModalRef<UGCModalComponent>,
        @Inject(MODAL_DATA) readonly data: NCmsUGC.IModalData,
        private client: Client
    ) {}

    /**
     * Close ugc
     */
    close() {
        this.modalRef.close();
    }

    get pcSlides() {
        return [1.15, 2.7, 1.35, 1.35][this.client.sizeId];
    }

    get pcSlidesCeil() {
        return Math.ceil(this.pcSlides);
    }

    get pcGutter() {
        return '16px';
    }
}
